import React, { useState } from "react";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { Tabs, Tab, Skeleton } from "@mui/material";
import "./TheParentDashboard.css";
import Speaker from "./imageFiles/Speaker.png";
import Ann_icon from "./imageFiles/Ann_icon.png";

export default function Announcements({
  allRecentAnnouncements,
  weeklyAnnouncements,
  monthlyAnnouncements,
  parent_dashboard_initial_loading,
}) {
  const [tabIndex, setTabIndex] = useState(0);
  const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);

  const skeletonList = Array(4).fill({});

  const renderAnnouncements = (data) => {
    return data?.map((item, index) => (
      <div
        className="announcement-row"
        key={index}
        onClick={() => setSelectedAnnouncement(item)}
      >
        <div className="announcement-icon">
          <img src={Speaker} alt="Announcement Icon" />
        </div>
        <div className="announcement-text">
          <p className="stdannouncement-title">
            {item?.announcement_title || "Announcement details"}
          </p>
          <p className="announcement-body">
            {item?.announcement_body?.length > 70
              ? `${item?.announcement_body.substring(0, 70)}...`
              : item?.announcement_body ||
                "There are many variations of passages of Lorem Ipsum available"}
          </p>
        </div>
      </div>
    ));
  };

  return (
    <div className="announcement-wrapper">
      <div className="announcement-header">
        <h5>Announcements</h5>
      </div>

      <div className="announcement-tabs">
        <div>&emsp;</div>
        <Tabs
          value={tabIndex}
          onChange={(e, val) => setTabIndex(val)}
          TabIndicatorProps={{
            style: { backgroundColor: "#A67EF3", height: "2px" },
          }}
        >
          <Tab label="All" />
          <Tab label="Last month" />
          <Tab label="7 Days" />
        </Tabs>
        <div>&emsp;</div>
      </div>

      <div className="announcement-list">
        {parent_dashboard_initial_loading ? (
          skeletonList.map((_, index) => (
            <div className="announcement-row" key={index}>
              <Skeleton variant="circular" width={30} height={30} />
              <div className="announcement-text">
                <Skeleton variant="text" width={220} height={22} />
                <Skeleton variant="text" width={160} height={18} />
              </div>
            </div>
          ))
        ) : (
          <>
            {tabIndex === 0 && renderAnnouncements(allRecentAnnouncements)}
            {tabIndex === 1 && renderAnnouncements(monthlyAnnouncements)}
            {tabIndex === 2 && renderAnnouncements(weeklyAnnouncements)}
          </>
        )}
      </div>

      {selectedAnnouncement && (
        <div
          className="announcement-modal"
          onClick={() => setSelectedAnnouncement(null)}
        >
          <div
            className="announcement-popup"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="announcement-modal-icon-wrapper">
              <div className="announcement-modal-icon">
                <img src={Ann_icon} alt="Announcement Icon" />
              </div>
            </div>
            <h2 className="announcement-title">
              {selectedAnnouncement.announcement_title}
            </h2>
            <div className="announcement-body">
              {selectedAnnouncement.announcement_body}
            </div>
            <div className="announcement-actions">
              <button
                className="announcement-btn cancel-btn"
                onClick={() => setSelectedAnnouncement(null)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}